<template>
  <button
    class="btn btn-lg gap-2 py-3 bg-primary/10 text-primary hover:bg-primary/20 dark:bg-primary/30 dark:text-primary dark:hover:bg-primary/40"
    data-testid="content-edit-regenerate-button"
  >
    <slot name="icon">
      <i v-if="icon" class="pi" :class="icon" />
    </slot>
    <span class="capitalize">{{ label }}</span>
  </button>
</template>

<script setup lang="ts">
defineProps<{
  label: string;
  /**
   * icon class from prime-vue
   */
  icon?: string;
}>();
</script>

<style scoped></style>
